module.exports = __webpack_public_path__ + "img/8.c7f78c54.jpg";